/**
 * Utility functions for text formatting
 */

/**
 * Converts ALL CAPS text to sentence case
 * @param {string} text - The text to convert
 * @returns {string} - The converted text in sentence case
 */
export const toSentenceCase = (text) => {
  console.log("text",text)
  if (!text) return '';

  if(text==="MAX_QUESTIONS_PER_SESSION_FOR_CHATAGENTCHAT"){
    return "Max questions per session for chat agent chat"
  }
  
  // Handle special cases for common limit patterns
  // const specialCases = {
  //   'MAX_CHAT_AGENT_CREATION_LIMIT': 'Max Chat AI Agent Creation Limit',
  //   'MAX_CHAT_SESSIONS_FOR_PLAYGROUND_CHAT_LIMIT': 'Max Chat Sessions For Playground Chat',
  //   'MAX_INBOUND_CALL_DURATION_SECONDS': 'Max Voice AI Inbound Call Duration (minutes)',
  //   'MAX_OUTBOUND_CALL_DURATION_SECONDS': 'Max Voice AI outbound Call Duration (minutes)',
  //   'MAX_AGENT_CREATION_LIMIT': 'Max AI Agent Creation Limit',
  //   'MAX_DOCUMENTS_UPLOAD_LIMIT': 'Max Documents Upload Limit',
  //   'MAX_CALLS_PER_USER': 'Max Voice AI Calls Per User',
  //   'MAX_CALL_DURATION_SECONDS': 'Max Voice AI Call Duration (minutes)',
  //   'MAX_AGENT_CHAT_LIMIT': 'Max AI Agent Chat Limit',
  //   'MAX_PLAYGROUND_CHAT_LIMIT': 'Max Playground Chat AI Limit',
  //   'MAX_QUESTIONS_FOR_AGENT_CHAT': 'Max Questions per AI Agent Chat',
  //   'MAX_QUESTIONS_FOR_PLAYGROUND_CHAT': 'Max Questions Per Playground AI Chat',
  //   'MAX_AGENT_UPDATE_LIMIT': 'Max AI Agent Update Limit',
  //   'MAX_VOICE_AGENT_CREATION_LIMIT': 'Max Voice AI Agent Creation Limit',
  //   'MAX_USER_CREATION_LIMIT': 'Max User Creation Limit',
  //   'PRICE': 'Price',
  //   'MAX_QUESTIONS_PER_SESSION_FOR_CHATAGENTCHAT': 'Max Questions Per Session For Chat AI Agent Chat',
  //   'MAX_QUESTIONS_PER_SESSION_FOR_VOICEAGENTCHAT': 'Max Questions Per Session For Voice AI Agent Chat',
  //   "MAX_CHAT_SESSIONS_FOR_CHATAGENT_LIMIT": 'Max Chat Sessions For Chat AI Agent Limit',
  //   "MAX_QUESTIONS_PER_SESSION_FOR_PLAYGROUNDCHAT": 'Max Questions Per Session For Playground AI Chat',
  //   "MAX_QUESTIONS_PER_SESSION_FOR_CHATAGENTCHAT": 'Max Questions Per Session For Chat AI Agent Chat',
  // };

  const specialCases = {
  // Feature name mappings
  'MAX_CHAT_AGENT_CREATION_LIMIT': 'Max Chat AI Agent Creation Limit',
  'MAX_CHAT_SESSIONS_FOR_PLAYGROUND_CHAT_LIMIT': 'Max Chat Sessions For Playground Chat',
  'MAX_INBOUND_CALL_DURATION_SECONDS': 'Max Voice AI Inbound Call Duration (minutes)',
  'MAX_OUTBOUND_CALL_DURATION_SECONDS': 'Max Voice AI Outbound Call Duration (minutes)',
  'MAX_AGENT_CREATION_LIMIT': 'Max AI Agent Creation Limit',
  'MAX_DOCUMENTS_UPLOAD_LIMIT': 'Max Documents Upload Limit',
  'MAX_CALLS_PER_USER': 'Max Voice AI Calls Per User',
  'MAX_CALL_DURATION_SECONDS': 'Max Voice AI Call Duration (minutes)',
  'MAX_AGENT_CHAT_LIMIT': 'Max AI Agent Chat Limit',
  'MAX_PLAYGROUND_CHAT_LIMIT': 'Max Playground Chat AI Limit',
  'MAX_QUESTIONS_FOR_AGENT_CHAT': 'Max Questions per AI Agent Chat',
  'MAX_QUESTIONS_FOR_PLAYGROUND_CHAT': 'Max Questions Per Playground AI Chat',
  'MAX_AGENT_UPDATE_LIMIT': 'Max AI Agent Update Limit',
  'MAX_VOICE_AGENT_CREATION_LIMIT': 'Max Voice AI Agent Creation Limit',
  'MAX_USER_CREATION_LIMIT': 'Max User Creation Limit',
  'PRICE': 'Price',
  'MAX_QUESTIONS_PER_SESSION_FOR_CHATAGENTCHAT': 'Max Questions Per Session For Chat AI Agent Chat',
  'MAX_QUESTIONS_PER_SESSION_FOR_VOICEAGENTCHAT': 'Max Questions Per Session For Voice AI Agent Chat',
  'MAX_CHAT_SESSIONS_FOR_CHATAGENT_LIMIT': 'Max Chat Sessions For Chat AI Agent Limit',
  'MAX_QUESTIONS_PER_SESSION_FOR_PLAYGROUNDCHAT': 'Max Questions Per Session For Playground AI Chat',
  'MAX_VOICE_AGENT_UPDATE_LIMIT': 'Max Voice AI Agent Update Limit',
  'MAX_CONCURRENT_CALLS': 'Max Concurrent Calls',
  'MAX_INBOUND_CALL_DURATION_MINUTES_PER_TENANT': 'Max Inbound Call Duration (minutes per tenant)',
  'MAX_OUTBOUND_CALL_DURATION_MINUTES_PER_TENANT': 'Max Outbound Call Duration (minutes per tenant)',
  'MAX_CALL_DURATION_MINUTES_PER_CALL': 'Max Call Duration (minutes per call)',
  "MAX_CHAT_AGENT_UPDATE_LIMIT": 'Max Chat AI Agent Update Limit',

  // Plan name mappings
  'Free': 'Free Plan',
  'Starter_Chat': 'Starter Chat Plan',
  'Starter_Voice': 'Starter Voice Plan',
  'Professional': 'Professional Plan',
  'Enterprise': 'Enterprise Plan',
};


  // Check if it's a special case first
  if (specialCases[text]) {
    return specialCases[text];
  }

  // General conversion for other ALL CAPS text
  return text
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Formats numbers with commas for better readability
 * @param {number|string} value - The value to format
 * @returns {string} - The formatted value
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '0';
  
  const num = typeof value === 'string' ? parseInt(value, 10) : value;
  if (isNaN(num)) return value;
  
  return num.toLocaleString();
};

/**
 * Formats duration from seconds to minutes
 * @param {number|string} seconds - Duration in seconds
 * @returns {string} - Formatted duration
 */
export const formatDuration = (seconds) => {
  if (!seconds || seconds === 0) return '0 min';
  
  const num = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  if (isNaN(num)) return seconds;
  
  const minutes = Math.floor(num / 60);
  return `${minutes} min`;
};

const PLAN_DISPLAY_NAME_BY_TOKEN = {
  starter_chat_user: 'Basic',
  starter_chat: 'Basic',
  basic: 'Basic',
  basic_user: 'Basic',
  basic_plan: 'Basic',
  starter_voice_user: 'Standard',
  starter_voice: 'Standard',
  standard: 'Standard',
  standard_user: 'Standard',
  professional_user: 'Advance',
  professional: 'Advance',
  advance: 'Advance',
  advanced: 'Advance',
  advance_user: 'Advance',
  enterprise_user: 'Pro',
  enterprise: 'Pro',
  pro: 'Pro',
  pro_user: 'Pro',
  pay_as_you_go: 'Pay As You Go',
  payg: 'Pay As You Go',
  free: 'Free',
};

const normalizePlanToken = (value = '') =>
  String(value).trim().toLowerCase().replace(/[\s-]+/g, '_');

/**
 * Replaces backend plan tokens in error messages with user-friendly plan names.
 * Example: "starter_chat_user" -> "Basic", "PRO" -> "Pro"
 */
export const mapPlanNamesInMessage = (messageText) => {
  const message = String(messageText || '');
  if (!message) return message;

  let formattedMessage = message;
  Object.entries(PLAN_DISPLAY_NAME_BY_TOKEN).forEach(([token, displayName]) => {
    const matcher = new RegExp(`\\b${token.replace(/_/g, '[_\\s-]?')}\\b`, 'gi');
    formattedMessage = formattedMessage.replace(matcher, displayName);
  });

  // Fallback for all-caps tokens like BASIC/STANDARD/ADVANCE/PRO/PAYG/FREE
  formattedMessage = formattedMessage.replace(/\b[A-Z][A-Z_\-\s]{2,}\b/g, (rawToken) => {
    const normalized = normalizePlanToken(rawToken);
    return PLAN_DISPLAY_NAME_BY_TOKEN[normalized] || rawToken;
  });

  return formattedMessage;
};